import { Component, computed, input } from '@angular/core';
import { IconName, provideIcons } from '@ng-icons/core';
import { lucideCheck, lucideCircleAlert, lucideCircleCheck, lucideInfo, lucideX } from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { ClassValue } from 'clsx';

export const listVariants = cva('component-small-medium px-sm flex items-center rounded-full', {
  variants: {
    variant: {
      default: 'bg-components-background-neutral-main text-components-content-neutral-primary',
      informative: 'bg-feedback-informative-lightest text-feedback-informative-main',
      warning: 'bg-feedback-warning-lightest text-feedback-warning-main',
      negative: 'bg-feedback-negative-lightest text-feedback-negative-main',
      positive: 'bg-feedback-positive-lightest text-feedback-positive-main',
    },
    size: {
      default: 'gap-xs py-xs w-fit',
      badge: 'size-xl',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});

export type ChipVariants = VariantProps<typeof listVariants>;

@Component({
  selector: 'app-chip',
  imports: [HlmIconImports],
  template: ` <div [class]="_computedClass()">
    @if (icon()) {
      <div>
        <ng-icon [name]="icon()" hlm size="sm" />
      </div>
    }
    <span class="w-full text-center">{{ label() }}</span>
  </div>`,
  providers: [provideIcons({ lucideCircleCheck, lucideCircleAlert, lucideInfo, lucideCheck, lucideX })],
})
export class ChipComponent {
  readonly label = input.required<string | number>();
  readonly icon = input<IconName>();

  readonly variant = input<ChipVariants['variant']>('default');
  readonly size = input<ChipVariants['size']>('default');
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(listVariants({ variant: this.variant(), size: this.size() }), this.userClass()),
  );
}
